import React, { useContext, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { TicketMeeting } from "@services/tickets/types";
import { getMeetings } from "@services/meetings";
import { MeetingInstance } from "@services/meetings/types";
import { FormContext } from "../context/formContext";
import Button from "@common/components/Button";

interface AddMeetingDialogProps {
  open?: boolean;
  onClose?: () => void;
  onMustPickMeeting: (meetings: MeetingInstance[]) => void;
}

const AddMeetingDialog = (props: AddMeetingDialogProps) => {
  const { form, dispatchHasChanged } = useContext(FormContext);
  const { ticket } = form;
  const { open = false, onClose = () => {}, onMustPickMeeting } = props;
  const { t } = useTranslation();
  const [meetingId, setMeetingId] = useState<string>("");
  const [errorMeetingId, setErrorMeetingId] = useState<string>("");

  const onConfirm = async () => {
    setErrorMeetingId("");
    if (meetingId != "") {
      var numbers = /^[0-9]+$/;
      if (meetingId.match(numbers)) {
        if (ticket.meetings) {
          dispatchHasChanged(true);
          let meetingid = Number(meetingId);
          var bFound = ticket.meetings.find(
            (meeting: TicketMeeting) => meeting.confirmationNumber == meetingid
          );

          if (bFound) {
            setErrorMeetingId("Meeting already linked with ticket.");
            return;
          }
        }
      } else {
        setErrorMeetingId(
          "Please enter a valid meeting ID with numeric characters only."
        );
        return;
      }

      var startdatetime = new Date();
      var stopdatetime = new Date();

      //logic in SY 5 could have been simplified to this, search between now and 1 week
      startdatetime.setDate(startdatetime.getDate() - 7);

      let meetings = await getMeetings(
        startdatetime,
        stopdatetime,
        7,
        0,
        "meetingId asc",
        7,
        {
          meetingId: [meetingId],
          purpose: [
            "RegularMeeting",
            "CertificationOfManaged",
            "CertificationOfUnmanaged",
            "Maintenance",
            "Other",
          ],
        }
      );
      if (meetings.list.length > 0) {
        if (meetings.list.length == 1) {
          let meeting = {
            confirmationNumber: meetings.list[0].meetingId,
            title: meetings.list[0].title,
            meetingInstanceId: meetings.list[0].id,
          };
          if ("" + meeting.confirmationNumber == meetingId) {
            if (!ticket?.meetings) ticket.meetings = [];
            ticket.meetings.push(meeting);
            setMeetingId("");
            onClose();
          } else {
            setErrorMeetingId(t("Please provide a valid meeting ID."));
          }
        } else {
          setMeetingId("");
          onMustPickMeeting(meetings.list);
        }
      } else {
        setErrorMeetingId(t("Please provide a valid meeting ID."));
      }
    } else {
      setErrorMeetingId(t("Field is required"));
    }
  };

  const onCancel = () => {
    setMeetingId("");
    setErrorMeetingId("");
    onClose();
  };

  return (
    <Dialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
      <DialogTitle>{t("Add Meeting")}</DialogTitle>
      <DialogContent>
        <FormControl
          fullWidth
          sx={(theme) => ({
            marginTop: 2,
            width: "100%",
            "& .MuiFormHelperText-root": {
              color: theme.palette.error.main,
            },
            "& .MuiInputLabel-root::after": {
              content: "'*'",
              color: theme.palette.error.main,
            },
          })}
        >
          <TextField
            id="meeting_id_textfield"
            label={t("ID")}
            value={meetingId}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setMeetingId(e.target.value)
            }
          />
          <FormHelperText>{errorMeetingId}</FormHelperText>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="white" onClick={onConfirm}>
          {t("Add Meeting")}
        </Button>
        <Button variant="outlined" color="greyed" onClick={onCancel}>
          {t("Cancel")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddMeetingDialog;
